
<h4 class="title">Add Fields</h4>
<div class="row">
<div class="col-md-12">
<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-3">
            <h5 class="form-lable">Field Name :</h5>
            <input type="text" pInputText [(ngModel)]="type" placeholder="Enter Field Name ">
        </div>

        <div class="col-md-3">
          <h5 class="form-lable">Fields detail :</h5>
          <input type="text" pInputText [(ngModel)]="fields_detail" placeholder="Enter Fields detail ">
      </div>

      <div class="col-md-3">
        <h5 class="form-lable">Data type :</h5>
        <p-dropdown [options]="profolio_list" [(ngModel)]="data_type" placeholder="Select Data type"
        optionLabel="y" [showClear]="true"></p-dropdown>
    </div>

    <div class="col-md-3">
      <h5 class="form-lable">Length :</h5>
      <input type="number" min="0" pInputText [(ngModel)]="length" placeholder="Enter length ">
  </div>

        <div class="col-md-6 mt-20">
            <button *ngIf="edit_f == false" type="button" class="btn btn-primary" (click)="add()">Add</button>
            <button  *ngIf="edit_f == true" type="button" class="btn btn-primary" (click)="edit()">Update</button>
            <button type="button" *ngIf="edit_f == true" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button>
        </div>

    </div>
</div>
</div>
<div class="col-md-12">
  <div class="search-hero">
      <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
          [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
  </div>
</div>
<div class="col-md-8 text-right">
  <!-- <button type="button" class="btn btn-primary mr-0" (click)="User_form()" >Add</button>  -->
</div>


<div class="col-md-12">

<div class="doc-table">
<div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

    <ng-template pTemplate="header">
        <tr class="thhead">
            <th class="th-1">
                S.No
            </th>
            <th>
              Field Name
            </th>
            <th>
              Fields Detail
            </th>
            <th>
              Data Type
            </th>
            <th>
              Length
            </th>
            <th>
                Created By
            </th>
            <th>Created At</th>
            <th>Updated At</th>
            <th style="width: 110px;text-align:center">
                Action
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="tdrow">
            <td>{{i+1}}</td>
            <td>{{item.fields}}</td>
            <td>{{item.fields_detail}}</td>
            <td>{{item.data_type}}</td>
            <td>{{item.length}}</td>
            <td>{{item.addedby}}</td>
            <td>{{item.createdAt | date}}</td>
            <td>{{item.updatedAt | date}}</td>
            <td class="act">
                <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit" (click)="show_edit(item)"></i>
                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete" (click)="delete(item._id)"></i>
            </td>
        </tr>
    </ng-template>
 </p-table>  </div>

</div>
</div>

